(() => {
  const STORAGE_KEY = 'large_orders';
  const CART_ATTRIBUTE_KEY = 'large_orders';
  const selectors = {
    toggle: '[data-large-orders-toggle]',
  };

  function normaliseState(value) {
    return value === 'on' ? 'on' : 'off';
  }

  function readStoredState() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'on' || stored === 'off') return stored;
    return null;
  }

  function writeStoredState(state) {
    sessionStorage.setItem(STORAGE_KEY, state);
  }

  function applyStateToToggles(toggleElements, state) {
    const pressed = state === 'on' ? 'true' : 'false';
    toggleElements.forEach((el) => el.setAttribute('aria-pressed', pressed));

    document.body.classList.toggle('large-orders-on', state === 'on');
    document.body.classList.toggle('large-orders-off', state !== 'on');
  }

  async function fetchCartState() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      });
      if (!response.ok) return 'off';

      const cart = await response.json();
      const attr = cart?.attributes?.[CART_ATTRIBUTE_KEY];
      return attr === 'on' ? 'on' : 'off';
    } catch {
      return 'off';
    }
  }

  async function persistCartState(state) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [CART_ATTRIBUTE_KEY]: state === 'on' ? 'on' : '',
          },
        }),
      });
    } catch {
      // No-op: cart persistence is best-effort.
    }
  }

  function bind(toggleElements) {
    const onClick = async () => {
      const current = normaliseState(readStoredState() || 'off');
      const next = current === 'on' ? 'off' : 'on';

      writeStoredState(next);
      applyStateToToggles(toggleElements, next);
      await persistCartState(next);
    };

    toggleElements.forEach((el) => el.addEventListener('click', onClick));
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const toggleElements = Array.from(document.querySelectorAll(selectors.toggle));
    if (!toggleElements.length) return;

    const stored = readStoredState();
    const initial = stored ? normaliseState(stored) : await fetchCartState();

    writeStoredState(initial);
    applyStateToToggles(toggleElements, initial);
    bind(toggleElements);
  });
})();
